export enum ERROR_TYPES {
  GENERAL = 'GENERAL'
}

export enum ERROR_CODE {
  DEFAULT = 'Something went wrong',
  API = 'API',
  NO_API_KEY = 'NO_API_KEY',
  NO_DATA = 'NO_DATA',
  NO_LANGUAGE_SELECTED = 'NO_LANGUAGE_SELECTED',
  USER_FIELDS_ERROR = 'USER_FIELDS_ERROR',
  USER_NOT_FOUND = 'USER_NOT_FOUND'
}

export interface Error {
  type: ERROR_TYPES
  code?: number
  message: string
}
